interface LinkIconProperties {
  height?: string | number;
  width?: string | number;
}

export default function LinkIcon({ width, height }: LinkIconProperties) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 16" version="1.1">
      <g
        id="Bookings-Dashboard-FINAL"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="CatchApp-Dashboard/Desktop-Final/MyEvents-(9)"
          transform="translate(-49.000000, -326.000000)"
          fill="currentColor"
        >
          <g id="CatchApp-Dashboard/Symbols/Menus">
            <g
              id="Icons/MainMenu/Settings/Grey3Fill-Copy-3"
              transform="translate(41.000000, 314.000000)"
            >
              <path
                d="M20.1314485,16.2059613 C19.5008556,16.0228298 18.8064127,16.08802 18.1995062,16.4421664 L18.0708498,16.5224925 L10.8853543,21.3037796 C9.69663834,22.0947991 9.34611194,23.7477954 10.103911,24.9880053 C10.8380288,26.1900565 12.3471184,26.5715815 13.5209023,25.8750982 L13.6334103,25.8043227 L16.4027461,23.9612843 C16.6922572,24.435704 17.0550946,24.8316327 17.4651039,25.1464703 L17.6210175,25.2607281 L14.549626,27.303681 C12.5688268,28.6222525 9.92953446,28.0126368 8.66693011,25.9443862 C7.43061116,23.9207447 7.96429908,21.2386813 9.84460512,19.8892817 L9.96913862,19.8031872 L17.1546341,15.0219001 C18.6241259,14.0439236 20.4536018,14.1315404 21.8166943,15.0842191 C22.2381404,15.3786884 22.6156373,15.7546227 22.9230719,16.208945 L23.0350247,16.3829843 C24.2738892,18.4054179 23.7402554,21.0874556 21.8599505,22.4362763 L21.7354171,22.5223322 L20.3871022,23.4194791 C19.8463758,23.2622814 19.3519866,22.9221245 19.002033,22.4169647 L18.9176105,22.2872476 L20.8192014,21.0223568 C21.97077,20.2560567 22.3357173,18.6813906 21.6684496,17.4550645 L21.6006447,17.337514 C21.2730442,16.8066871 20.7950492,16.4383153 20.2627127,16.2508401 L20.1285521,16.2077506 L20.1314485,16.2059613 Z M25.4502284,12.696167 C27.4310276,11.3775955 30.07032,11.9878282 31.3329243,14.0554619 C32.5692433,16.0791033 32.0361216,18.7611667 30.1552854,20.1105663 L30.0307158,20.1966608 L22.8452203,24.9785649 C21.4247116,25.9233458 19.6678177,25.8729654 18.3209934,25.0080058 L18.1831601,24.9156289 C17.7596649,24.622805 17.3819403,24.2475411 17.0740652,23.7929141 L16.9619333,23.6187148 L16.8838458,23.4858243 C15.7505935,21.4800578 16.3002258,18.8856725 18.1374752,17.566106 L18.2647329,17.4781329 L19.6124566,16.580986 C20.1537287,16.7381836 20.6481599,17.0778148 20.9981167,17.5828937 L21.0825395,17.7126004 L19.1809486,18.9774912 C17.9922326,19.7691277 17.6417062,21.421507 18.3995053,22.662334 C18.724705,23.1948696 19.2020116,23.5638986 19.7347213,23.7514648 L19.868997,23.7945655 L20.0049357,23.8298231 C20.5977926,23.9663413 21.2367946,23.8870771 21.8003484,23.558291 L21.9290046,23.4779726 L29.1145001,18.6966855 C30.3032161,17.905666 30.6537425,16.2526697 29.8959434,15.0124597 C29.1618256,13.8098108 27.6532908,13.4288462 26.4790041,14.1253651 L26.3664441,14.1961424 L23.5971083,16.0391808 C23.3075972,15.5647611 22.9447598,15.1688323 22.5347505,14.8539948 L22.3788369,14.7397369 L25.4502284,12.696167 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

LinkIcon.defaultProps = {
  height: '24px',
  width: '24px',
};
